module.exports = __webpack_public_path__ + "img/Hover-Circle.3fc92e01.svg";